import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import NationalityForm from '../components/NationalityForm';
import { useCreateNationality } from '../hooks/useNationalityMutations';

export default function NationalityCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreateNationality();

  const handleSubmit = (data: any) => {
    mutation.mutate(data, { onSuccess: () => navigate('/nationalities') });
  };

  return (
    <div>
      <PageHeader back title={t('nationalities.addTitle')} subtitle={t('nationalities.addSubtitle')} />
      <Card>
        <NationalityForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
